// extracted by mini-css-extract-plugin
export default {"recos":"y6-z","productCardOverride":"z6-z","rowHasBadge":"A6-z"};